const firstFiniteNumber = (...values) => {
    for (const value of values) {
        if (value === null || value === undefined || value === '') continue;
        const number = Number(value);
        if (Number.isFinite(number)) return number;
    }
    return 0;
};

export const getArticlePricing = (article = {}) => {
    const netPrice = firstFiniteNumber(
        article.net_price,
        article.vkNetto,
        article.vk_netto,
        article.price
    );
    const overridePurchasePrice = firstFiniteNumber(
        article.purchase_price_override,
        article.backup_purchase_price
    );
    const sourcePurchasePrice = firstFiniteNumber(
        article.original_purchase_price,
        article.source_purchase_price,
        article.purchase_price,
        article.ekNetto,
        article.ek_netto
    );
    const purchasePrice = overridePurchasePrice > 0
        ? overridePurchasePrice
        : sourcePurchasePrice;

    return {
        netPrice,
        purchasePrice,
        sourcePurchasePrice,
        hasPurchasePriceOverride: overridePurchasePrice > 0,
        isNegativeMargin: netPrice > 0 && purchasePrice > 0 && netPrice < purchasePrice
    };
};

export const hasNegativeArticleMargin = (article = {}) => getArticlePricing(article).isNegativeMargin;